export const getters = {
	subscriptions: state => state.subscriptions,
	subscription: state => id => { return state.subscriptions.filter(o => (parseInt(o.id) === parseInt(id)))[0] },
	currentSubscription: state => state.subscriptions.length > 0 ? state.subscriptions[0] : null,
	lastPaymentFailInfo: state => state.lastPaymentFailInfo
}



// WEBPACK FOOTER //
// ./src/common/store/Subscriptions/getters.js